// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2CpeT","additionalInfo":"AgreementModal_additionalInfo__3LGj4"};